import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  mainContainer: {
    padding: theme.spacing(0, 5),
    marginTop: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  tabContainer: {
    backgroundColor: theme.palette.common.white,
    paddingLeft: theme.spacing(5),
  },
  awsImage: {
    width: '24px',
    height: '22px',
  },
  microsoftImage: {
    width: '16px',
    height: '16px',
  },
}))
